import { generateTimeId as getId } from "../generateTimeId";
import { getActiveBranchIds1 } from "../multipleBranch/getActiveBranchId";

export function extractData(data) {
  /**
   * this function only filters those feedbacks where
   * foodNameHaving issue is answered. ie customer gave poor rating to food.
   * and full data of feedback is returned
   */
  let output = [];

  data.forEach((item) => {
    let found = false;
    item.data.optionQuestions.forEach((element) => {
      if (element.title == "foodNameHavingIssue" && element.answer != "")
        found = true;
    });
    if (found) {
      output.push(item);
    }
  });
  //console.log(output);
  return output;
}

export function tabulateData(data) {
  // we tabulate data branchId wise
  // data is in formate
  /**
   *[{
   * admin_id: "456456456",data:{bioDetails:"646"},
   * _id:"5456"
   * }]
   */

  /**we need to output data that can be shown on table
   * only NECESSAry info that will be used is passed on further.
   * data = {admin_id,_id,FoodName,foodIssue,isArchive}
   */
  let activeBranches = getActiveBranchIds1();
  let superOutput = [];
  activeBranches.forEach((bId) => {
    let obj1 = {
      bId: bId,
      data: [],
    };

    data.map((d) => {
      if (d.admin_id == bId) {
        let obj = {
          _id: d._id,
          admin_id: d.admin_id,
          foodName: d.data.optionQuestions[1].answer,
          foodIssue: d.data.optionQuestions[0].answer,
          isArchived: d.archiveFoodComment,
        };
        obj1.data.push(obj);
      }
    });
    superOutput.push(obj1);
  });

  const dummyOutput = [
    {
      _id: "67343e6ecae7305cf911d8f1",
      admin_id: "1",
      foodName: "paneer1",
      foodIssue: "very bad exp1",
      isArchived: false,
    },
    {
      _id: "67343dcdcae7305cf911d8b3",
      admin_id: "2",
      foodName: "paneer2",
      foodIssue: "very bad exp2",
      isArchived: false,
    },
    {
      _id: "673439f9cae7305cf911d893",
      admin_id: "3",
      foodName: "paneer3",
      foodIssue: "very bad exp3",
      isArchived: false,
    },
    {
      _id: "67343920cae7305cf911d87d",
      admin_id: "4",
      foodName: "paneer4",
      foodIssue: "very bad exp4",
      isArchived: false,
    },
    {
      _id: "6734340bcae7305cf911d849",
      admin_id: "5",
      foodName: "paneer15",
      foodIssue: "very bad exp5",
      isArchived: false,
    },
  ];
  return superOutput;
}

export function createTags(data, bId) {
  //console.log("CREATING TAGS");

  // while creating tags we will check mergeTagsData so
  // as to not create tags for already created tags and merged
  // merged tags will be added to created tags data at the end.

  /** input data is in form
   * [{_id,admin_id,foodIssue,foodName}]
   */
  /** format of output data
   *
   * obj={
   * mainId,
   * data:[{
   *    foodName,
   *    idForTags
   * }]}
   */

  let mergedTags = getMergedTagDatalocallyById(bId);

  // now we need to iterate through mergedTags and re Confirm if any
  // feedback_id was archived or not to reflect latest archiving state.
  // ALSO include only those mergedTags out of all locally stored merged Tags whose
  // feedback data is present in mainData (ie they match time,date given by user)
  // .and  other than those mergedTags are no demanded by user and are older then mainDat
  // and hence should be avoided in including in the food comment.s
  let mainData = JSON.parse(sessionStorage.getItem("mainData"));

  // only those mergedtags (food comment) will be selected
  // which have coresponding feedback data in mainData
  let newMergedTags = mergedTags.filter((mt) => {
    let newComments = mt.data.filter((comment) => {
      let _id = comment.feedback_id;
      let archiveStatus;

      let isPresent = mainData.findIndex((feedback) => {
        if (feedback._id == _id) {
          archiveStatus = feedback.archiveFoodComment;
          return true;
        }
      });

      comment.isArchived = archiveStatus;
      if (isPresent > -1) {
        return comment;
      }
    });
    ////console.log(newComments);
    if (newComments.length > 0) {
      mt.data = [...newComments];
      return mt;
    }
  });

  //PROCESS ENDS and now newMergedTags is appropriate merged Tags.
  ////console.log(newMergedTags);
  //This newMergedTags is subset of mergedTags in localstorage but all foodComments willbe
  //only from those feedbacks which are inside mainData(data of feedback in session storage)
  let tagData = [];

  /**
   * we wil create an array that will have all the feedback_id which
   * have been merged by user hence their fresh tags wont be created.
   */
  const mergedTagsArr = [];
  let arrOfAlreadyMergedTags = [];
  newMergedTags?.forEach((item) => {
    item.data.forEach((comment) => {
      arrOfAlreadyMergedTags.push(comment.feedback_id);
    });
    mergedTagsArr.push(item);
  });

  //console.log(mergedTagsArr);
  //console.log(newMergedTags);
  // // Now we start creating fresh tags and we keep checking arrOfAlreadyMergedTags
  // // if id is presenet in above array then we leave it out.

  data.forEach((d) => {
    // //console.log(arrOfAlreadyMergedTags);
    // //console.log(arrOfAlreadyMergedTags.includes(d._id));
    if (!arrOfAlreadyMergedTags.includes(d._id)) {
      let obj = {
        mainId: d._id,
        feedback_idArr: [d._id],
        data: [
          {
            foodName: d.foodName,
            feedback_id: d._id,
            foodIssue: d.foodIssue,
            isArchived: d.isArchived,
          },
        ],
      };

      tagData.push(obj);
    }
  });

  //console.log(tagData);
  return [...tagData, ...mergedTagsArr];
}

export function mergeTagData(data) {
  // data is state variable mergeContainer data.
  // we return one object like
  //{mainId:"fdsafs",data:[{foodName:"paner",feedback_id:"h89"}]}
   //console.log(data);

  let output = {
    mainId: getId(),
    creationDate: new Date().getTime(),
    feedback_idArr: [],
  };
  let subData = [];
  data.forEach((item) => {
    // //console.log(item.data);
    //now we loop through sub data since this tag may be already merged and have
    // multiple entries.
    output.feedback_idArr.push(...item.feedback_idArr);
    item.data.forEach((i) => {
      subData.push(i);
    });
  });
  output.data = [...subData];
  return output;
}

export function getMergedTagDatalocallyById(bId) {
  const data = JSON.parse(sessionStorage.getItem("mergedTagsData"));
//console.log("getting merged tags data from local storage");
  //console.log(data);

  if (data == null) return null;


  const output = data.filter((item) => {
    if (item._id == bId){
      return true;
   } 
  });
  //console.log(output[0].mergedFoodTagsData);

  if(output.length == 0) return null;
  return output[0].mergedFoodTagsData;
}
